import { html, View } from 'rune-ts';
import klass from './LikeView.module.scss';
import { CardProductError } from '@services/MarppleShop/renderApp/pages/Curation/components/CardProductView.ts';

const bright_icon_html = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 18 18"
  fill="none"
>
  <path
    d="M16.6262 4.5352C15.9068 2.82433 14.3241 2 12.7415 2C11.3027 2 9.87186 2.68435 9.08852 4.00639C9.07253 4.02972 9.05654 4.06083 9.04056 4.08416C9.02457 4.10749 9.00858 4.11526 8.9846 4.11526C8.96062 4.11526 8.94464 4.10749 8.92865 4.08416C8.91266 4.06083 8.89668 4.02972 8.88069 4.00639C8.10534 2.68435 6.66655 2 5.22776 2C3.66107 2 2.0784 2.82433 1.359 4.5352C0.391816 6.83711 1.52686 9.38009 3.00562 11.2232C5.97913 14.6605 8.40109 15.7725 8.90467 15.9825C8.96862 16.0058 9.03256 16.0058 9.09651 15.9825C9.60009 15.7803 12.0141 14.6682 14.9956 11.2232C16.4663 9.38009 17.6094 6.83711 16.6422 4.5352H16.6262Z"
    fill="#141414"
    fill-opacity="0.25"
  />
  <path
    d="M12.7412 1.5C14.3999 1.5 16.0824 2.32223 16.9443 4.03516H16.9746L17.1035 4.3418C18.1817 6.90843 16.8867 9.65542 15.3867 11.5352L15.3799 11.543L15.374 11.5508C12.3391 15.0576 9.85845 16.2152 9.2832 16.4463L9.26758 16.4521C9.09304 16.5158 8.90792 16.5158 8.7334 16.4521L8.71191 16.4443C8.14422 16.2076 5.65698 15.0513 2.62793 11.5498L2.62109 11.543L2.61523 11.5361C1.10559 9.65449 -0.179715 6.90793 0.898438 4.3418L1.06055 3.99316C1.92815 2.30917 3.59631 1.50007 5.22754 1.5C6.6369 1.5 8.06712 2.09579 8.98535 3.27441C9.90681 2.09683 11.33 1.50007 12.7412 1.5Z"
    stroke="white"
    stroke-opacity="0.6"
  />
</svg>`;

const blue_icon_html = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 20 20"
  fill="none"
>
  <path
    d="M18.5795 4.83439C17.7701 2.85439 15.9896 1.90039 14.2091 1.90039C12.5905 1.90039 10.9808 2.69239 10.0996 4.22239C10.0816 4.24939 10.0636 4.28539 10.0456 4.31239C10.0276 4.33939 10.0097 4.34839 9.98268 4.34839C9.9557 4.34839 9.93772 4.33939 9.91973 4.31239C9.90175 4.28539 9.88376 4.24939 9.86578 4.22239C8.99351 2.69239 7.37487 1.90039 5.75623 1.90039C3.99371 1.90039 2.2132 2.85439 1.40388 4.83439C0.315793 7.49839 1.59272 10.4414 3.25633 12.5744C6.60152 16.5524 9.32623 17.8394 9.89276 18.0824C9.96469 18.1094 10.0366 18.1094 10.1086 18.0824C10.6751 17.8484 13.3908 16.5614 16.745 12.5744C18.3996 10.4414 19.6855 7.49839 18.5974 4.83439H18.5795Z"
    fill="#1C75FF"
  />
  <path
    d="M14.209 1.40039C16.0744 1.40039 17.9546 2.35703 18.9033 4.33398H18.9336L19.0605 4.64551C20.2538 7.56738 18.8242 10.7093 17.1396 12.8809L17.1279 12.8965C13.7209 16.9463 10.9388 18.2809 10.2998 18.5449L10.2842 18.5508C10.099 18.6202 9.90195 18.6203 9.7168 18.5508L9.70605 18.5469L9.69531 18.542C9.06331 18.2709 6.27341 16.9388 2.87402 12.8965L2.86816 12.8887L2.8623 12.8818C1.16712 10.7083 -0.251803 7.5669 0.941406 4.64551C1.83536 2.45845 3.81196 1.40052 5.75586 1.40039C7.3548 1.40039 8.96806 2.10746 9.9834 3.49219C11.003 2.10852 12.6081 1.40043 14.209 1.40039Z"
    stroke="white"
    stroke-opacity="0.6"
  />
</svg>`;

export type TProps =
  | {
      size: 'Large';
      state: 'On';
    }
  | {
      size: 'Large';
      state: 'Off';
    }
  | {
      size: 'Medium';
      state: 'Off';
    }
  | {
      size: 'Medium';
      state: 'On';
    }
  | {
      size: 'Small';
      state: 'Off';
    }
  | {
      size: 'Small';
      state: 'On';
    };

/**
 * https://www.figma.com/design/J3pxvmlv167DXuLToyL3Mg/%EC%83%81%ED%92%88-%EC%B9%B4%EB%93%9C-UI?node-id=368-190053&m=dev
 */
export class LikeView extends View<TProps> {
  setState(state: TProps['state']) {
    this.data.state = state;
    this.redraw();
  }

  protected override template(props: TProps) {
    if (props.size === 'Large' && props.state === 'On') {
      return html`<span class="${klass.size_large}">${blue_icon_html}</span>`;
    } else if (props.size === 'Large' && props.state === 'Off') {
      return html`<span class="${klass.size_large}">${bright_icon_html}</span>`;
    } else if (props.size === 'Medium' && props.state === 'On') {
      return html`<span class="${klass.size_medium}">${blue_icon_html}</span>`;
    } else if (props.size === 'Medium' && props.state === 'Off') {
      return html`<span class="${klass.size_medium}">${bright_icon_html}</span>`;
    } else if (props.size === 'Small' && props.state === 'On') {
      return html`<span class="${klass.size_small}">${blue_icon_html}</span>`;
    } else if (props.size === 'Small' && props.state === 'Off') {
      return html`<span class="${klass.size_small}">${bright_icon_html}</span>`;
    } else {
      throw new CardProductError();
    }
  }
}
